import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom"
import Header from "./Layout/Header";
import Footer from "./Layout/Footer";
import TopInfo from "./TopInfo";
import Slider from "../components/Slider";


const Layout: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        document.scrollingElement?.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <>
            <TopInfo />
            <Header />
            <div id="canvas">
                <div id="box_wrapper">
                    <main>
                        <Outlet />
                    </main>
                </div>
            </div>
            <Footer />

        </>
    )
}

export default Layout;